export default "__VITE_ASSET__CuJ_cri9__"